import React, { Component } from 'react';
import './App.css';
import { Map, TileLayer, CircleMarker, Popup, Polygon, Polyline, LayerGroup, ScaleControl} from 'react-leaflet';
import 'leaflet/dist/leaflet.css'
import L from 'leaflet';
import moment from 'moment';
import timezone from 'moment-timezone';

// Declare but don't initialize these variables, so babel will compile. They
// will be set in a special script tag in index.html if needed for override
var manLat, manLon, manZoom, OVERRIDE_ZOOM; 

var offset = new Date().getTimezoneOffset();

class ControlInitialLayerUpdates extends Component{
   // This thing is a class constructor
  constructor(props) {
    // This lets us access props of the parent class of app
    super(props)
  }
  // Subtract 360 to show quakes on both copies of Australia, etc.
  getMyMirrorLatLon(Quake) {
    const lat = Quake.geometry.coordinates[1];
    const lon = Quake.geometry.coordinates[0] - 360;
    const myLatLon = [lat, lon];
    //const myLatLon = [38.58, -121.49]
    return myLatLon;
  }
  getMyLatLon(Quake) {
  	const lat = Quake.geometry.coordinates[1];
  	const lon = Quake.geometry.coordinates[0];
    const myLatLon = [lat, lon];
    //const myLatLon = [38.58, -121.49]
    return myLatLon;
  }
  getMyRadius(Quake){
  	const mag = Quake.properties.mag;
  	let size;
  	if (mag < 3){size=6} 
  	else if ((mag >= 3) && (mag < 4)){size=8}
    else if ((mag >= 4) && (mag < 5)){size=10}
    else if ((mag >= 5) && (mag < 6)){size=12}
    else if ((mag >= 6) && (mag < 7)){size=14}
    else if ((mag >= 7) && (mag < 8)){size=16}
    else if ((mag >= 8) && (mag < 9)){size=18}
  	else if (mag >= 9){size=20}
  	else{console.log("Should never get here")}
    return size;
  }
  getMyFillColor(Quake){
  	let fillColor
  	const time = Quake.properties.time //TIme is reported in milliseconds since epoch, not seconds!
  	var d = Date.now();
    //var epochMilliSeconds = d.getTime();
  	const isLT1H = Boolean((d - 3600000) <= time)
    const isLT1D = Boolean(((d - 3600000) > time) && ((d - 86400000) <= time))
    const isLT1W = Boolean(((d - 86400000) > time) && ((d - 604800000) <= time))
  	if ((isLT1H === false) && (isLT1D === false) && (isLT1W === false)){
  		console.log("Should never get here. Quake may be more than a week old")
      fillColor='#91cc7f'
  	} else{
      if (isLT1H === true){fillColor='#ef4346'}
      else if (isLT1D === true){fillColor='#5962ad'}
	    else {fillColor='#f7f277'}
  	}
    console.log(fillColor)
    return fillColor;
  }	
  // For canvas (ie CircleMarker), the elements are layered as they are added to the DOM. Putting the 
  // markers in time order was not working consistently to layer the circles - worked on initial 
  // load but then not on later clicks. zIndexOffset does not work with CircleMarker, but you can choose from
  // the default panes for the marker to be displayed on. So now we at least have all the 1-hour events on top
  // of the other events and so on, although they may still be out of order within their pane on subsequent clicks
  getMyMapPane(Quake){
    let pane
    const time = Quake.properties.time //TIme is reported in milliseconds since epoch, not seconds!
    var d = Date.now();
    //var epochMilliSeconds = d.getTime();
    const isLT1H = Boolean((d - 3600000) <= time)
    const isLT1D = Boolean(((d - 3600000) > time) && ((d - 86400000) <= time))
    const isLT1W = Boolean(((d - 86400000) > time) && ((d - 604800000) <= time))
    if ((isLT1H === false) && (isLT1D === false) && (isLT1W === false)){
      console.log("Should never get here. Quake may be more than a week old")
      pane="shadowPane"
    } else{
      if (isLT1H === true){pane="tooltipPane"}
      else if (isLT1D === true){pane="markerPane"}
      else {pane="shadowPane"}
    }
    //console.log(pane)
    return pane;
  }
  // 2 react lifecycle methods for optimization
  // Only updates if filtered data is not blank and #quakes changes
  // may want to add new rules.
  // Looks like thos works for just asking it to compare old and new filteredData
  // so if any quake changes it updates.
  shouldComponentUpdate(nextProps,nextState){
   //if ((this.props.filteredData !== []) && (this.props.filteredData.length !== nextProps.filteredData.length)){
    if ((this.props.filteredData !== []) && (this.props.filteredData !== nextProps.filteredData)){
      return true
    } else {
      return false
    }
  }
  componentDidUpdate(prevProps,prevState){
  	var thing = 'Earthquakes updated'
  	var imagesLoaded = require('imagesloaded') // does this need to live out here?
    imagesLoaded('#quakesLayer',function(){
      document.getElementById('quakesUpdated').style.display = 'block';
      //console.log("Just set display to visible!")
      //console.log(this)
      f()
    });
    // Had major trouble with context inside imagesLoaded callback so rewote with 
    // arrow function to preserve controlInitialLayerUpdates as context
    var f = () => {
    	//console.log("When I ran f, this is the this I got", this)
    	this.props.cb2(thing)
    	// Needs to make info fade away after a shoer amount of time
    	setTimeout(function(){
          //alert("I am setTimeout");
          document.getElementById('quakesUpdated').style.display = 'none';
        },3000); //delay is in milliseconds 
    } 
  }
  render(){
     const myPosition = [38.58, -121.4944];
     //console.log("Filtered data in layer is:", this.props.filteredData)
    return(
    	 <LayerGroup id="quakesLayer">
    	{this.props.filteredData.map((Quake) => {
        //Ignore this quake if its info is screwed up
        if ((Quake.properties.mag != null) && (Quake.geometry.coordinates != null)){
          // Note Moment's default is local time
    		  let dayLocal = moment(Quake.properties.time).format('MM/DD/YYYY h:mm a') 
          let localTimeString = "Time (Local): "+ dayLocal
    	    const isLocalTimeString = (localTimeString !== "")   
    	    let dayUTC = moment(Quake.properties.time).utc().format('MM/DD/YYYY HH:mm z')
          let dataProducts = (Quake.properties.types).split(',')
          let isdyfi = (dataProducts.filter(product => product==="dyfi") !=="")
          let isShakemap = (dataProducts.filter(product => product==="shakemap") !=="")
          let dyfi
          let shakemap
          //console.log("Data products is:", dataProducts)
          if (isdyfi !== ""){
            dyfi = Quake.properties.url + '/dyfi/intensity/'
          }
          if (isShakemap !== ""){
            shakemap = Quake.properties.url + '/shakemap/intensity/'
          } 
          //console.log("Time value as I am plotting quakes is:", Quake.properties.time)
          return (
            <CircleMarker key={Quake.properties.code}
              center={this.getMyLatLon(Quake)}
              radius={this.getMyRadius(Quake)}
              color={'black'}
              weight={1}
              fillColor={this.getMyFillColor(Quake)}
              fillOpacity={1}
              pane={this.getMyMapPane(Quake)}>
            <Popup>Magnitude: {(Quake.properties.mag).toFixed(1)}<br/>
              {localTimeString}
              {isLocalTimeString 
                ? <br/>
                : null
              }
              Time (UTC): {dayUTC}<br/>
              Depth (km): {(Quake.geometry.coordinates[2]).toFixed(1)}<br/>
              {Quake.properties.place}<br/>
              <a href={Quake.properties.url} target={"_blank"}>Earthquake Details</a><br/>
              {isdyfi
                ? <span><a href={dyfi} target={"_blank"}>Did You Feel It?</a><br/></span>
                : null
              }
              {isShakemap
                ? <a href={shakemap} target={"_blank"}>Shakemap</a>
                : null
              }
            </Popup>
            </CircleMarker> 
          )            
        }
      })}
      {/*} We have to plot this whole thing twice to get the mirrored version for zooming out*/}
      {this.props.filteredData.map((Quake) => {
        //Ignore this quake if its info is screwed up
        if ((Quake.properties.mag != null) && (Quake.geometry.coordinates != null)){
          let dayLocal = moment(Quake.properties.time).format('MM/DD/YYYY h:mm a') 
          let localTimeString = "Time (Local): "+ dayLocal
          const isLocalTimeString = (localTimeString !== "")   
          //console.log(dayLocal)    
          let dayUTC = moment(Quake.properties.time).utc().format('MM/DD/YYYY hh:mm a z')
          let dataProducts = (Quake.properties.types).split(',')
          let isdyfi = (dataProducts.filter(product => product==="dyfi") !=="")
          let isShakemap = (dataProducts.filter(product => product==="shakemap") !=="")
          //console.log(Quake.properties.url)
          let dyfi
          let shakemap
          //console.log("Data products is:", dataProducts)
          if (isdyfi !== ""){
            dyfi = Quake.properties.url + '/dyfi/intensity/'
          }
          if (isShakemap !== ""){
            shakemap = Quake.properties.url + '/shakemap/intensity/'
          } 
          console.log("Time value as I am plotting quakes is:", Quake.properties.time)
          return (
            <CircleMarker key={Quake.properties.code + 'mirror'}
              center={this.getMyMirrorLatLon(Quake)}
              radius={this.getMyRadius(Quake)}
              color={'black'}
              weight={1}
              fillColor={this.getMyFillColor(Quake)}
              fillOpacity={1}
              pane={this.getMyMapPane(Quake)}>
            <Popup>Magnitude: {(Quake.properties.mag).toFixed(1)}<br/>
              {localTimeString}
              {isLocalTimeString 
                ? <br/>
                : null
              }
              Time (UTC): {dayUTC}<br/>
              Depth (km): {(Quake.geometry.coordinates[2]).toFixed(1)}<br/>
              {Quake.properties.place}<br/>
              <a href={Quake.properties.url} target={"_blank"}>Earthquake Details</a><br/>
              {isdyfi
                ? <span><a href={dyfi} target={"_blank"}>Did You Feel It?</a><br/></span>
                : null
              }
              {isShakemap
                ? <a href={shakemap} target={"_blank"}>Shakemap</a>
                : null
              }
            </Popup>
            </CircleMarker>
          )  
        }
      })}
    	</LayerGroup>
    	)
  }
}

class Quakesmap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      centerlat: 37.16,//41.998,
      centerlng: -119.449, //-124.208,
      zoom: 5,
      initialMapLoad: true
    }
  }
  passLoadingInfo = (loadMessage) => {
  	//console.log("Here is the loading info!", loadMessage)
  	this.props.cb(loadMessage)
  }
  shouldComponentUpdate(nextProps,nextState){
   if ((this.props.filteredData !== []) && (this.props.filteredData.length !== nextProps.filteredData.length)){
      return true
    } else if ((this.props.filteredData !==[]) && (this.state.centerlat !== nextState.centerlat)){
      console.log("this component should update")
      return true
    } else if ((this.props.selectedFaults !== []) && (this.props.selectedFaults !== nextProps.selectedFaults)){
      console.log("Fault settings changed! this component should update")
      return true

  }  else {
      return false
    }
  }
  componentDidMount(){
    var myTimerVar = setInterval(() => {
      const epochTIme = Date.now();
      let myCenterLng, myCenterLat, myInitialZoom
      if ((typeof window.OVERRIDE_ZOOM !== 'undefined') && ( window.OVERRIDE_ZOOM === 1)){
        if ((typeof window.manLat !== 'undefined') && ( window.manLat !== null)){
          if ((typeof window.manLon !== 'undefined') && ( window.manLon !== null)){
            if ((typeof window.manZoom !== 'undefined') && ( window.manZoom !== null)){
              myCenterLat = window.manLat;
              myCenterLng = window.manLon;
              myInitialZoom = window.manZoom;
              this.setState({centerlat:myCenterLat, centerlng:myCenterLng, zoom:myInitialZoom, initialMapLoad: false})
            } 
          }
        }
      }
      else {
        // Map should zoom to most recent quake above 3.5 that is also less than 2 days old
        // and is also not west of -126 (way out in ocean) and not south of 32.5 (Mexico)
        const bigCAQuakes = this.props.filteredData
          .filter(Quake=> (Quake["properties"]["mag"] >= 3.5))
          .filter(Quake=> (Quake.properties.time >= (epochTIme - 172800000)))
          .filter(Quake=> ((Quake.properties.net === 'nc') || (Quake.properties.net === 'ci')))
          .filter(Quake=> ((Quake.geometry.coordinates[0] >= -126) && (Quake.geometry.coordinates[1] >= 32.5)))
        //console.log ("here are the big quakes on the map", bigCAQuakes)
        if (bigCAQuakes.length != 0){
          var newestBigQuake = bigCAQuakes[0]
          for (var i=0; i< bigCAQuakes.length; i++){
            if (bigCAQuakes[i].properties.time > newestBigQuake.properties.time){
              newestBigQuake = bigCAQuakes[i]
            }
          }
          if ((typeof newestBigQuake != 'undefined') && ( newestBigQuake != null)){
            myCenterLat = newestBigQuake.geometry.coordinates[1];
            myCenterLng = newestBigQuake.geometry.coordinates[0];
            myInitialZoom = 10;
          }      
          const position = [myCenterLat, myCenterLng]
          if ((position[0] != 'undefined') && (position != 'position')){
            this.setState({centerlat:myCenterLat, centerlng:myCenterLng, zoom:myInitialZoom, initialMapLoad: false})
          } 
        }  else if (this.props.filteredData.length != 0){
            this.setState({initialMapLoad: false})
          }
      }  
    }, 100); // set this to update frequently to avoid flash of non-centered map at beginning
    var myCheckingVar = setInterval(() => {
       if (this.state.initialMapLoad == false){
            clearInterval(myTimerVar)  // need to clear the interval after map updates
            clearInterval(myCheckingVar) 
            //console.log("Intervals cleared")
          }  
        }, 200); 
  }
  //for (var i=0; i < myFaultArray.length; i++){
    //  var array = []
    //  for (var j=0; j < myFaultArray[i].length; j++){
     //   console.log("myFaultArray[i][j] is", myFaultArray[i][j])
     //   array.push([myFaultArray[i][j][1], myFaultArray[i][j][1]])
     // }
     // console.log(array)
    //}
  getFaultData = (fault) =>{
      var array = []
      for (var j=0; j < fault.length; j++){
        array.push([fault[j][1], fault[j][0]])
      }
      console.log(array)
    //const position = [[35,-122], [35,-121]]
    const position = array
    return position
  }
  render() {  
  	//console.log("Filtered data in map is", this.props.filteredData)
  	//map url here: url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
    const style= {
      right: '0px',
      left: '0px',
      bottom: '0px',
      top: '0px',
      height: '100%',
      width: '100%'
    }
    return (
      <Map attributionControl={false} style={style} center={[this.state.centerlat, this.state.centerlng]} zoom={this.state.zoom} worldCopyJump={true} renderer={L.canvas({padding:0.05, tolerance:10})}>
      <TileLayer
      url='https://tile.openstreetmap.org/{z}/{x}/{y}.png?'
      />
      {/*<TileLayer
      url='http://server.arcgisonline.com/ArcGIS/rest/services/USGS_National_Map/MapServer/tile/{z}/{y}/{x}.png'
      />*/}
      <ScaleControl position={'topleft'}/>
            <ControlInitialLayerUpdates cb2={this.passLoadingInfo.bind(this)} filteredData={this.props.filteredData}/>
      </Map>
    );
  }
}   

export default Quakesmap;